import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Table, Form, Button } from "react-bootstrap";
import toast from "react-hot-toast";
import { makeParams } from "../../../../../api/makeRequest";
import StudentService from "../../../../../services/student.service";
import Select from "react-select";
import ReactDatePicker from "react-datepicker";
import { CSVLink } from "react-csv";
import { NormalText } from "../../../../../components/Text/TableText.formats";
import { useNavigate } from "react-router";
import { FaEye } from "react-icons/fa";
import ViewEnrollementsDetailModal from "../../../../../components/Modals/ViewEnrollementsDetail.modal";
import { IsLoading } from "../../../../../App.context";
import { countries } from "../../../../../utilis/country.utiils";
import TablePagination from "../../../../../components/Pagination";


export const AllStudents = () => {
    const [allStudents, setAllStudents] = useState<any[]>([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState("");
    const [total, setTotal] = useState(0);
    const [csvData, setCSVData] = useState<any[]>([]);
    const navigate = useNavigate();
    const [enrollments, setEnrollments] = useState<any[]>([]);
    const [country, setCountry] = useState<any>("");
    const { setLoading }: any = useContext(IsLoading);


    const [startDate, setStartDate] = useState<any>(moment().subtract(15, 'days').toDate());
    const [endDate, setEndDate] = useState<any>(moment().toDate());


    async function getAllStudents() {
        const start = moment(startDate);
        const end = moment(endDate);

        const errors: any = [];

        if (start.isAfter(end)) {
            errors.push("Start date should be less than end date");
        }

        if (start.isSame(end, 'day')) {
            errors.push("Start date and end date should not be same");
        }

        if (Math.abs(start.diff(end, 'days')) > 365) {
            errors.push("Date range should not be more than 365 days");
        }

        if (errors.length > 0) {
            errors.forEach((msg: any) => toast.error(msg));
            return;
        }

        let params = [
            { index: 'pageNumber', value: pageNumber },
            { index: 'pageSize', value: pageSize },
            { index: "searchText", value: search },
            { index: "startDate", value: start.format("DD/MM/YYYY") },
            { index: "endDate", value: end.format("DD/MM/YYYY") }
        ];

        const qParams = makeParams(params);
        const payload = country?.value ? { country: country.value } : {};

        setLoading(true);
        try {
            const res = await StudentService.getAllStudents(qParams, payload);
            if (res.status === 200) {
                setAllStudents(res.data?.users || []);
                setTotal(res.data?.count || 0);
            }
        } catch (err) {
            toast.error("Unable to fetch Students");
        } finally {
            setLoading(false);
        }
    }



    async function getCSVData() {
        let params = [
            { index: 'pageNumber', value: 1 },
            { index: 'pageSize', value: 9999999999 },
            { index: "searchText", value: search }
        ];

        params.push({ index: "startDate", value: moment(startDate).format("DD/MM/YYYY") });
        params.push({ index: "endDate", value: moment(endDate).format("DD/MM/YYYY") });

        let qParams = makeParams(params);
        let payload = {};

        if (country && country?.value) {
            payload = { country: country?.value }
        }

        setLoading(true);

        await StudentService.getAllStudents(qParams, payload)
            .then((res) => {
                if (res.status === 200) {
                    createCSVData(res.data?.users);
                }
            })
            .catch((err: any) => {
                toast.error("Unable to fetch Students");
            })
            .finally(() => {
                setLoading(false);
            });
    }


    function createCSVData(allData: any[]) {
        if (!allData?.length) {
            return false;
        }

        let data = allData?.map((item: any) => {
            return {
                "Name": item?.name ? item.name : "N.A.",
                "Email": item?.email,
                "Phone": item?.phone,
                "Country": item?.country,
                "Birthday": item?.birthday ? moment(item?.birthday).format("YYYY-MM-DD") : "N/A",
                "Created At": moment(item?.createdAt).format("YYYY-MM-DD"),
                "Instrument": item?.onboarding?.instrument || "N/A",
                "State": item?.onboarding?.state || "N/A",
                "Age Group": item?.onboarding?.age_group || "N/A",
                "Address": item?.fullAddress?.firstLine ? (item?.fullAddress?.firstLine + " " + item?.fullAddress?.secondLine + " " + item?.fullAddress?.zipCode) : "N/A",
                "Campaign": item?.onboarding?.utms?.utm_campaign || "N/A",
                "Source": item?.onboarding?.utms?.utm_source || "N/A",
                "Medium": item?.onboarding?.utms?.utm_medium || "N/A",
                "Paid Enrollments": item?.paid_enrollments?.length,
                "Demo Enrollments": item?.demo_enrollment?.length,
            }
        });

        setCSVData(data);
    }

    useEffect(() => {
        getAllStudents();
        getCSVData()
    }, [pageNumber, pageSize, search]);


    useEffect(() => {
        setTimeout(() => {
            getAllStudents();
        }, 500);
    }, [search]);

    return (
        <>
            <div className="d-flex justify-content-between">
                <div className="d-flex gap-2">
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold text-secondary fs-12">
                            Search
                        </Form.Label>
                        <Form.Control type="text" placeholder="Search" onChange={(e) => setSearch(e.target.value)} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold text-secondary fs-12">
                            Date Range
                        </Form.Label>
                        <div className="d-flex gap-2">
                            <ReactDatePicker
                                onChange={(e: any) => {
                                    setStartDate(e);
                                }}
                                selected={startDate}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                placeholderText="Select Start Date"
                            />
                            <ReactDatePicker
                                onChange={(e: any) => {
                                    setEndDate(e);
                                }}
                                selected={endDate}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                placeholderText="Select End Date"
                            />
                        </div>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold text-secondary fs-12">
                            Country
                        </Form.Label>
                        <Select
                            className="p-0"
                            options={countries.map((country) => {
                                return {
                                    label: country,
                                    value: country,
                                };
                            })}
                            value={country}
                            onChange={(e) => {
                                setCountry(e);
                            }}
                            isClearable
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Button style={{ marginTop: 30 }} onClick={getAllStudents}>Apply Filters</Button>
                    </Form.Group>
                </div>
                <div className="">
                    <CSVLink data={csvData} filename={"all-students.csv"}>
                        <Button size="sm" variant="primary">Download</Button>
                    </CSVLink>
                </div>
            </div>
            <Table bordered hover responsive size="sm">
                <thead>
                    <tr className="text-secondary" style={{ fontSize: "12px" }}>
                        <th>#</th>
                        <th>Student Name/Email/Country</th>
                        <th>Birthday</th>
                        {/* <th>Enrollment Type</th> */}
                        <th>Sign Up Date</th>
                        <th>Instruments</th>
                        <th>State</th>
                        <th>Age Group</th>
                        <th>Address</th>
                        <th>Campaign/Source/Medium</th>
                        <th>Paid Enrollments</th>
                        <th>Demo Enrollments</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        allStudents?.length > 0 ? allStudents?.map((item: any, index: number) => {
                            return (
                                <tr>
                                    <td>{pageSize * (pageNumber - 1) + index + 1}</td>
                                    <td>
                                        <u
                                            className="text-primary fs-12 fw-bold fs-underline cursor-pointer"
                                        >
                                            {item?.name
                                                ? item.name
                                                : "N.A."}
                                        </u>
                                        <div>
                                            (<NormalText value={item?.email || "N.A."} />)
                                        </div>
                                        <div className="text-info fw-bold">
                                            {item.phone ? item.phone : "--"}
                                        </div>
                                        <div className="text-info fw-bold">
                                            {item.country ? item.country : "--"}
                                        </div>
                                    </td>
                                    <td>{item?.birthday ? moment(item?.birthday).format("YYYY-MM-DD") : "N/A"}</td>
                                    {/* <td>Full-time</td> */}
                                    <td>{moment(item?.createdAt).format("YYYY-MM-DD") || "N/A"}</td>
                                    <td>{item?.onboarding?.instrument || "N/A"}</td>
                                    <td>{item?.onboarding?.state || "N/A"}</td>
                                    <td>{item?.onboarding?.age_group || "N/A"}</td>
                                    <td>{item?.fullAddress?.firstLine ? (item?.fullAddress?.firstLine + " " + item?.fullAddress?.secondLine + " " + item?.fullAddress?.zipCode) : "N/A"}</td>
                                    {/* <td></td> */}
                                    <td>
                                        (<NormalText value={item?.onboarding?.utms?.utm_campaign || "N.A."} />)
                                        (<NormalText value={item?.onboarding?.utms?.utm_source || "N.A."} />)
                                        (<NormalText value={item?.onboarding?.utms?.utm_medium || "N.A."} />)
                                    </td>
                                    <td>
                                        <NormalText value={item?.paid_enrollments?.length} />
                                        {
                                            item?.paid_enrollments?.length > 0 &&
                                            <FaEye
                                                className="text-primary ms-1 cursor-pointer"
                                                onClick={() => setEnrollments(item?.paid_enrollments)}
                                            />
                                        }
                                    </td>
                                    <td>
                                        <NormalText value={item?.demo_enrollment?.length} />
                                        {
                                            item?.demo_enrollment?.length > 0 &&
                                            <FaEye
                                                className="text-primary ms-1 cursor-pointer"
                                                onClick={() => setEnrollments(item?.demo_enrollment)}
                                            />
                                        }
                                    </td>
                                </tr>
                            )
                        })
                            :
                            <tr>
                                <td colSpan={13}>
                                    No data found.
                                </td>
                            </tr>
                    }
                </tbody>
            </Table>

            <TablePagination
                total={total}
                currentPage={pageNumber}
                perPage={pageSize}
                handlePageChange={setPageNumber}
                setPerPage={setPageSize}
            />

            <ViewEnrollementsDetailModal
                show={enrollments && enrollments.length > 0}
                setShow={() => setEnrollments([])}
                enrollments={enrollments}
            />
        </>

    );
};

export const PaidStudents = () => {

    const [allStudents, setAllStudents] = useState<any[]>([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState("");
    const [csvData, setCSVData] = useState<any[]>([]);
    const { loading, setLoading }: any = useContext(IsLoading);
    const [country, setCountry] = useState<any>("");
    const [total, setTotal] = useState(0);

    const [startDate, setStartDate] = useState<any>(moment().subtract(15, 'days').toDate());
    const [endDate, setEndDate] = useState<any>(moment().toDate());


    const navigate = useNavigate();

    // async function getAllPaidUsers() {
    //     const start = moment(startDate);
    //     const end = moment(endDate);

    //     const errors: any = [];

    //     if (start.isAfter(end)) {
    //         errors.push("Start date should be less than end date");
    //     }

    //     if (start.isSame(end, 'day')) {
    //         errors.push("Start date and end date should not be same");
    //     }

    //     if (Math.abs(start.diff(end, 'days')) > 365) {
    //         errors.push("Date range should not be more than 365 days");
    //     }

    //     if (errors.length > 0) {
    //         errors.forEach((msg: any) => toast.error(msg));
    //         return;
    //     }

    //     let params = [
    //         { index: 'pageNumber', value: pageNumber },
    //         { index: 'pageSize', value: pageSize },
    //         { index: "searchText", value: search },
    //         { index: "startDate", value: start.format("DD/MM/YYYY") },
    //         { index: "endDate", value: end.format("DD/MM/YYYY") }
    //     ];

    //     const qParams = makeParams(params);
    //     const payload = country?.value ? { country: country.value } : {};

    //     setLoading(true);
    //     await StudentService.getAllPaidStudents(qParams, payload)
    //         .then((res) => {
    //             if (res.status === 200) {
    //                 setAllStudents(res.data?.enrollments || []);
    //                 setTotal(res.data?.count || 0);
    //             }
    //         })
    //         .catch((err: any) => {
    //             toast.error("Unable to fetch Students");
    //         })
    //         .finally(() => {
    //             setLoading(false);
    //         })

    //     params = [
    //         { index: 'pageNumber', value: 1 },
    //         { index: 'pageSize', value: 99999999999999 },
    //         { index: "searchText", value: search }
    //     ];

    //     params.push({ index: "startDate", value: moment(startDate).format("DD/MM/YYYY") });
    //     params.push({ index: "endDate", value: moment(endDate).format("DD/MM/YYYY") });

    //     q = makeParams(params);
    //     payload = {};

    //     if (country) {
    //         payload = { country: country?.value }
    //     }
    //     setLoading(true);
    //     await StudentService.getAllPaidStudents(q, payload)
    //         .then((res) => {
    //             if (res.status === 200) {
    //                 createCSVData(res.data?.enrollments);
    //             }
    //         })
    //         .catch((err: any) => {
    //             toast.error("Unable to fetch Students");
    //         })
    //         .finally(() => {
    //             setLoading(false);
    //         })
    // }

    async function getAllPaidUsers() {
        const start = moment(startDate);
        const end = moment(endDate);
        const errors: string[] = [];

        // Date validations
        if (start.isAfter(end)) {
            errors.push("Start date should be less than end date");
        }

        if (start.isSame(end, 'day')) {
            errors.push("Start date and end date should not be same");
        }

        if (Math.abs(start.diff(end, 'days')) > 365) {
            errors.push("Date range should not be more than 365 days");
        }

        if (errors.length > 0) {
            errors.forEach((msg) => toast.error(msg));
            return;
        }

        const formattedStartDate = start.format("DD/MM/YYYY");
        const formattedEndDate = end.format("DD/MM/YYYY");

        const buildParams = (pageNumber: number, pageSize: number) => {
            return makeParams([
                { index: 'pageNumber', value: pageNumber },
                { index: 'pageSize', value: pageSize },
                { index: "searchText", value: search },
                { index: "startDate", value: formattedStartDate },
                { index: "endDate", value: formattedEndDate }
            ]);
        };

        const buildPayload = () => (country?.value ? { country: country.value } : {});

        try {
            setLoading(true);

            const paginatedParams = buildParams(pageNumber, pageSize);
            const paginatedPayload = buildPayload();

            const paginatedRes = await StudentService.getAllPaidStudents(paginatedParams, paginatedPayload);
            if (paginatedRes.status === 200) {
                setAllStudents(paginatedRes.data?.enrollments || []);
                setTotal(paginatedRes.data?.count || 0);
            }

            const allDataParams = buildParams(1, Number.MAX_SAFE_INTEGER);
            const allDataRes = await StudentService.getAllPaidStudents(allDataParams, paginatedPayload);

            if (allDataRes.status === 200) {
                createCSVData(allDataRes.data?.enrollments);
            }

        } catch (error) {
            toast.error("Unable to fetch Students");
        } finally {
            setLoading(false);
        }
    }


    function createCSVData(allData: any[]) {
        if (!allData?.length) {
            // toast.error("No data found");
            return false;
        }

        let data = allData?.map((item: any) => {
            return {
                "Name": item?.name,
                "Email": item?.email,
                "Phone": item?.phone,
                "country": item?.country,
                "Total Paid Enrollments": item?.paid_enrollment,
                "Total Paid": item?.total_paid,
                "Total Sessions": item?.total_sessions,
                "Sessions Completed": item?.completed_sessions,
                "Sessions Remaining": item?.left_sessions,
                "Request Left": item?.request_left,
            }
        });

        setCSVData(data);
    }

    useEffect(() => {
        getAllPaidUsers();
    }, [pageNumber, pageSize, search]);


    useEffect(() => {
        setTimeout(() => {
            getAllPaidUsers();
        }, 500);
    }, [search]);



    return (
        <>
            <div className="d-flex justify-content-between">
                <div className="d-flex gap-2">
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold text-secondary fs-12">
                            Search
                        </Form.Label>
                        <Form.Control type="text" placeholder="Search" onChange={(e) => setSearch(e.target.value)} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold text-secondary fs-12">
                            Date Range
                        </Form.Label>
                        <div className="d-flex gap-2">
                            <ReactDatePicker
                                onChange={(e: any) => {
                                    setStartDate(e);
                                }}
                                selected={startDate}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                placeholderText="Select Start Date"
                            />
                            <ReactDatePicker
                                onChange={(e: any) => {
                                    setEndDate(e);
                                }}
                                selected={endDate}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                placeholderText="Select End Date"
                            />
                        </div>
                    </Form.Group>
                    <Form.Group className="mb-3 w-50">
                        <Form.Label className="fw-bold text-secondary fs-12">
                            Country
                        </Form.Label>
                        <Select
                            options={countries.map((country) => {
                                return {
                                    label: country,
                                    value: country,
                                };
                            })}
                            value={country}
                            onChange={(e) => {
                                setCountry(e);
                            }}
                            isClearable
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Button style={{ marginTop: 30 }} onClick={getAllPaidUsers}>Apply Filters</Button>
                    </Form.Group>
                </div>
                <div className="">
                    <CSVLink data={csvData} filename={"paid-students.csv"}>
                        <Button size="sm" variant="primary">Download</Button>
                    </CSVLink>
                </div>
            </div>
            <Table bordered hover responsive size="sm">
                <thead>
                    <tr className="text-secondary" style={{ fontSize: "12px" }}>
                        <th>#</th>
                        <th>Student Name/Email/Country</th>
                        <th>Paid Enrollments</th>
                        <th>Total Paid</th>
                        <th>Total Sessions</th>
                        <th>Sessions Completed</th>
                        <th>Sessions Left</th>
                        <th>Requests Left</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        allStudents?.length > 0 ? allStudents?.map((item: any, index: number) => {
                            return (
                                <tr>
                                    <td>{pageSize * (pageNumber - 1) + index + 1}</td>
                                    <td>
                                        <u
                                            className="text-primary fs-12 fw-bold fs-underline cursor-pointer"
                                            onClick={() => {
                                                navigate(
                                                    "/admin/search/student/detail/" +
                                                    item?.student_id
                                                );
                                            }}
                                        >
                                            {item.name || "N.A."}
                                        </u>
                                        <div>
                                            (<NormalText value={item.email || "N.A."} />)
                                        </div>
                                        <div className="text-info fw-bold">
                                            {item?.phone ? item.phone : "--"}
                                        </div>
                                        <div className="text-info fw-bold">
                                            {item.country ? item.country : "--"}
                                        </div>
                                    </td>
                                    <td>{item?.paid_enrollment || 0}</td>

                                    <td>₹{item?.total_paid || 0}</td>
                                    <td>{item?.total_sessions || 0}</td>
                                    <td>{item?.completed_sessions || 0}</td>
                                    <td>{item?.left_sessions || 0}</td>
                                    <td>{item?.request_left || 0}</td>
                                </tr>
                            )
                        })
                            :
                            <tr>
                                <td colSpan={10}>
                                    No data found.
                                </td>
                            </tr>
                    }
                </tbody>
            </Table>

            <TablePagination
                total={total}
                currentPage={pageNumber}
                perPage={pageSize}
                handlePageChange={setPageNumber}
                setPerPage={setPageSize}
            />
        </>
    );
};